<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR SOLICITAÇÃO DE MATRÍCULA' : 'NOVA SOLICITAÇÃO DE MATRÍCULA'" titleIcon="fas fa-user-plus">
            <el-form label-position="top" :model="form" ref="formRef" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Tipo de solicitação" prop="tipo_solicitacao_matricula_id" :rules="[$requiredChange]">
                            <el-select v-model="form.tipo_solicitacao_matricula_id" filterable style="width:100%;">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Data da solicitação" prop="data_solicitacao" :rules="[$requiredChange]">
                            <el-date-picker v-model="form.data_solicitacao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Situação">
                            <el-select v-model="form.status" style="width:100%;">
                                <el-option v-for="s in STATUS" :key="s.v" :label="s.l" :value="s.v"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-tabs v-model="abaSolicitante" type="border-card">
                    <el-tab-pane label="Aluno já cadastrado" name="aluno">
                        <el-form-item label="Aluno">
                            <el-select v-model="form.aluno_id" filterable remote :remote-method="buscarAluno"
                                :loading="loadAluno" placeholder="Digite o nome..." style="width:100%;"
                                @change="onSelecionarAluno">
                                <el-option v-for="a in alunosBusca" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label="Candidato (novo)" name="candidato">
                        <el-row :gutter="10">
                            <el-col :sm="14">
                                <el-form-item label="Nome do candidato">
                                    <el-input v-model="form.solicitante_nome"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="10">
                                <el-form-item label="Documento (CPF/RG)">
                                    <el-input v-model="form.solicitante_documento"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>

                <el-row :gutter="10" class="u-mt-10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Curso / série desejada">
                            <el-select v-model="form.curso_id" filterable clearable placeholder="Selecione" style="width:100%;">
                                <el-option v-for="c in cursos" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Observação">
                    <el-input type="textarea" v-model="form.observacao" :rows="4"></el-input>
                </el-form-item>

                <el-form-item label="Resposta / parecer">
                    <el-input type="textarea" v-model="form.resposta" :rows="3"></el-input>
                </el-form-item>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/solicitacao-matricula"><el-button>VOLTAR</el-button></router-link>
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
const STATUS = [
    { v: 1, l: 'Aberta' }, { v: 2, l: 'Em análise' },
    { v: 3, l: 'Deferida' }, { v: 4, l: 'Indeferida' }, { v: 5, l: 'Cancelada' }
]
export default {
    data () {
        return {
            STATUS,
            form: this.formVazio(),
            modoEdicao: false,
            tipos: [], cursos: [],
            abaSolicitante: 'aluno',
            alunosBusca: [], loadAluno: false
        }
    },
    mounted () {
        this.carregarTipos()
        this.carregarCursos()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        } else {
            this.form.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
            this.form.data_solicitacao = new Date().toISOString().slice(0, 10)
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        formVazio () {
            return {
                instituicao_id: null, tipo_solicitacao_matricula_id: null,
                aluno_id: null, solicitante_nome: '', solicitante_documento: '',
                curso_id: null, data_solicitacao: null, status: 1,
                observacao: '', resposta: ''
            }
        },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/solicitacao-matricula/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                Object.keys(this.form).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.form[k] = reg[k] })
                if (reg.aluno) { this.alunosBusca = [reg.aluno]; this.abaSolicitante = 'aluno' }
                else if (reg.solicitante_nome) this.abaSolicitante = 'candidato'
            })
        },
        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-solicitacao-matricula/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
        },
        carregarCursos () {
            this.$axios.get(`${this.baseUrl()}/api/curso/getAllCurso`, this.$store.getters.getHeaderAuth)
                .then(r => { this.cursos = Array.isArray(r.data) ? r.data : (r.data && r.data.data ? r.data.data : []) })
                .catch(() => {})
        },
        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunosBusca = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBusca = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        onSelecionarAluno () { this.form.solicitante_nome = ''; this.form.solicitante_documento = '' },
        salvar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                const inst = this.$store.state.config.instituicao
                if (!inst || !inst.id) {
                    window.eventBus.$emit('alert', { msg: 'Selecione uma instituição.', type: 'warning' }); return
                }
                const payload = { ...this.form, instituicao_id: inst.id }
                // Limpa o solicitante não usado conforme a aba
                if (this.abaSolicitante === 'aluno') { payload.solicitante_nome = null; payload.solicitante_documento = null }
                else { payload.aluno_id = null }

                const url = this.modoEdicao
                    ? `${this.baseUrl()}/api/solicitacao-matricula/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/solicitacao-matricula/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo.', type: 'success' })
                    this.$router.push('/admin/solicitacao-matricula')
                }).catch(e => this.$store.commit('throwException', e))
            })
        }
    }
}
</script>
